export enum InvoiceTimespan {
  TmHours = 'allUninvoicedHours',
  TmSince = 'allUninvoicedSince',
}
